import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { memo } from "react";
import { OutboundLabelForm } from "../outbound-labels";

export const productSyncFieldsForm = groupInput({
  tags: input<boolean>(),
  title: input<boolean>(),
  sku: input<boolean>(),
});

export type ProductSyncFieldsForm = InputSchema.Input<
  typeof productSyncFieldsForm
>;

export type ProductSyncFieldsValue = InputSchema.Value<
  typeof productSyncFieldsForm
>;

export const productSyncFieldsDefault: ProductSyncFieldsValue = {
  tags: false,
  title: false,
  sku: false,
};

export const ProductSyncFieldsCard = memo(function ProductSyncFieldsCard({
  input,
}: {
  input: OutboundLabelForm;
}) {
  const { productSyncFields } = input.inputs;

  return (
    <Card title="Product Update Sync Fields" w="full">
      <Flex dir="column" gap="md">
        <Text fontSize="sm">
          Select which additional product changes should trigger a resync of
          eligible open OMS fulfillment groups. Shopify supports tags, title,
          and SKU; CommentSold supports tags and SKU. For TikTok products
          sourced from Shopify, only SKU is supported by these toggles.
        </Text>
        <Text fontSize="xs" textColor="secondary">
          Bin, barcode, weight, and received status changes are checked
          independently of these toggles, where supported by the marketplace and
          product source.
        </Text>
        <RedoToggle
          label="Sync tags"
          setValue={productSyncFields.inputs.tags.setValue}
          size="sm"
          value={productSyncFields.inputs.tags.value}
        />
        <RedoToggle
          label="Sync title"
          setValue={productSyncFields.inputs.title.setValue}
          size="sm"
          value={productSyncFields.inputs.title.value}
        />
        <RedoToggle
          label="Sync SKU"
          setValue={productSyncFields.inputs.sku.setValue}
          size="sm"
          value={productSyncFields.inputs.sku.value}
        />
      </Flex>
    </Card>
  );
});
